<template>
<div class='order-card'>
  <div class='content-header'>
    <p>确认订单</p>
  </div>

  <div class='content-form'>
    <el-form class='content-form' label-width="160px">
      <el-form-item label="套餐名称">
        <p class='package-name'>{{product.name}}&nbsp;&nbsp;&nbsp;{{product.price}}&nbsp;元/年</p>
      </el-form-item>
      <el-form-item label="套餐内容">
        <ul class='package-details'>
          <li>
            <span>项目额度</span>
            <span class='right'>{{product.permanent ? `${product.permanent} 个` : '不限个数' }}</span>
          </li>
          <li v-if="product.sub_account">
            <span>子账号</span>
            <span class='right'>{{product.sub_account}}&nbsp;个</span>
          </li>
          <li v-if="!product.logo">
            <span>自定义加载页</span>
            <span class='right'>免费</span>
          </li>
          <li v-if="!product.export">
            <span>导出</span>
            <span class='right'>免费</span>
          </li>
          <li v-if="product.custom_cs">
            <span>企业专属服务</span>
          </li>
          <li>
            <span class='target-intro'>{{product.target_intro}}</span>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="支付方式">
        <el-radio-group theme='info' class='payment' v-model='payType'>
          <el-radio-button label='wechat'>{{$t('common.order.wechat')}}</el-radio-button>
          <el-radio-button label='alipay'>{{$t('common.order.alipay')}}</el-radio-button>
        </el-radio-group>
        <a class='info contactUs' @click='$contactMarket' v-if="product.price > 1000">
            联系销售
        </a>
      </el-form-item>
      <el-form-item label="优惠码（选填）" :class="{'is-error': errors.has('promoteCode')}">
        <el-input class='promteInput' v-model='promoteCode' @blur="checkPrice">
          <el-button slot="append" @click='checkPrice'>
            使用
          </el-button>
        </el-input>
        <span class='promoteDescription' v-if="!priceChecking && promoteDescription">
            <i class='ppj-icon-ok'></i>{{promoteDescription}}
        </span>
        <span class="el-form-item__error">{{errors.first('promoteCode')}}</span>
      </el-form-item>

      <el-form-item>
        <p class='price'>应付金额：<span class='actualPrice'>{{actualPrice}}</span>&nbsp;元
          <span class='sub-price' v-if="actualPrice !== originalPrice">
            订单总额：{{originalPrice}}&nbsp;元&nbsp;&nbsp;&nbsp;优惠：{{discount}}&nbsp;元
        </span>
        </p>
      </el-form-item>

      <el-form-item>
        <el-button type='primary' @click='placeOrder'>提交</el-button>
        <el-button type='text' @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>
  </div>

</div>
</template>

<script>
import Validator from '@/mixins/validator'
import packages from '@/config/packages'
import lodash from 'lodash'

let i18n = {
  messages: {
    'zh-cn': {}
  }
}

export default {
  data() {
    return {
      promoteCode: null,
      promoteDescription: null,
      originalPrice: null,
      actualPrice: null,
      discount: null,
      payType: 'wechat',
      priceChecking: false
    }
  },
  mixins: [Validator],
  computed: {
    product() {
      let _index = lodash.findIndex(packages, { type: this.$route.query.type })

      return _index ? packages[_index] : null
    }
  },
  methods: {
    placeOrder() {
      let vm = this

      if (vm.errors.count() > 0) {
        return
      }

      vm.$order({
        package: vm.product.package,
        promote_code: vm.promoteCode,
        payment_method: vm.payType,
        success: function() {
          vm.$router.push('/profile')
        },
        error: function(error) {
          if (error.type === 'InvalidPromoteCodeError') {
            vm.errors.add('promoteCode', error.message)
          }
        }
      })
    },
    checkPrice() {
      let vm = this
      vm.priceChecking = true
      vm.errors.remove('promoteCode')
      vm.$store.dispatch('quota/price', {
        package: vm.product.package,
        promote_code: vm.promoteCode
      }).then(res => {
        vm.priceChecking = false
        let data = res.data
        vm.discount = data.discount_total
        vm.originalPrice = data.item_total
        vm.actualPrice = data.total
        vm.promoteCode = data.promote_code

        if (data.valid_promote) {
          vm.promoteDescription = data.message
          vm.errors.remove('promoteCode')
        } else {
          vm.errors.add('promoteCode', data.message)
          vm.promoteDescription = null
        }
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkPrice()
    })
  },
  i18n
}
</script>

<style lang='scss' scoped>
.order-card {
    width: $page-width-small;
    min-height: $min-height-base;
    background-color: $color-white-base;
    margin: $margin-base auto 0;
    box-shadow: $box-shadow-base;
    padding: 0 $margin-base $margin-base;
    .content-header {
        overflow: hidden;
        border-bottom: $border-base;
        color: $font-color-strong;
        em {
            font-style: normal;
        }

        .hint {
            font-size: $font-size-small;
            vertical-align: bottom;
            padding-top: $font-size-base - $font-size-small;
        }
    }

    .content-form {
        margin: $margin-base auto;
        width: 600px;

        p {
            margin: 0;
        }

        .package-name {
            font-weight: bold;
            color: $font-color-strong;
        }

        .package-details {
            list-style: none;
            width: 300px;
            border: 1px solid $color-info;
            background-color: $color-info-bg;
            padding: 5px 20px;
            margin-top: 0;
            line-height: 2;

            .target-intro {
                color: $color-info;
            }
        }

        .contactUs {
            &:active,
            &:hover {
                color: darken($color-info, 10%);
                text-decoration: underline;
            }
        }

        .promteInput {
            width: 200px;

            .el-button {
                background-color: $color-white-base;
                color: $font-color-base;
            }
        }

        .promoteDescription {
            margin-left: 1.5em;
            color: $color-primary;

            .ppj-icon-ok {
                margin-right: 0.4em;
            }
        }

        .price {
            .actualPrice {
                color: $color-primary;
            }

            .sub-price {
                margin-left: 1em;
                font-size: $font-size-small;
                color: $font-color-light;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?382d20d6